import { NumberPatternType, Validate } from '@dreryk/react-common';

import {
   getPreciseDosagePortionMaxValue,
   getPreciseDosagePortionMinValue,
   getPreciseDosagePortionPrecision,
   getPreciseDosagePortionStep,
} from '~libs.shared.prescription';

import { ExtendedDosageFormBean, ExtendedDosageFormController } from '../ExtendedDosageForm.types';

import { StyledPortionNumberInput } from './PortionNumberInput.styled';
import { registerStageField, StageFieldName } from './StageFieldList.utils';

type PortionNumberInputProps = Pick<ExtendedDosageFormController, 'register'> & {
   readonly name: StageFieldName;
   readonly defaultValue: number;
   readonly testId: string;
   readonly zeroAllowed?: boolean;
   readonly validate?: Validate<ExtendedDosageFormBean>;
};

export const PortionNumberInput = (props: PortionNumberInputProps): JSX.Element => {
   return (
      <StyledPortionNumberInput
         testId={props.testId}
         controller={registerStageField<number | null>(props.register, props.name, {
            required: true,
            validate: props.validate,
         })}
         defaultValue={props.defaultValue}
         stepValue={getPreciseDosagePortionStep()}
         precision={getPreciseDosagePortionPrecision()}
         min={props.zeroAllowed ? 0 : getPreciseDosagePortionMinValue()}
         max={getPreciseDosagePortionMaxValue()}
         pattern={NumberPatternType.POSITIVE_FLOAT}
         autoComplete={false}
         compact
      />
   );
};
